import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "../views/MainPages/LoginPage.vue";

const routes = [
  {
    path: "/",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/LandingPage",
    name: "LandingPage",
    component: () =>
      import(
        /* webpackChunkName: "LandingPage" */ "../views/MainPages/LandingPage.vue"
      ),
    children: [
      {
        path: "/TeamsList",
        name: "TeamsList",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/TeamsList.vue"
          ),
      },
      {
        path: "/Members",
        name: "Members",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/Members.vue"
          ),
      },
      {
        path: "/Administrator",
        name: "Administrator",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/Administrator.vue"
          ),
      },
      {
        path: "/Apps",
        name: "Apps",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/Apps.vue"
          ),
      },
      {
        path: "/AuditLogs",
        name: "AuditLogs",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/AuditLogs.vue"
          ),
      },
      // {
      //   path: "/Broadcast",
      //   name: "Broadcast",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "LandingPage" */ "../views/ChildPages/Broadcast.vue"
      //     ),
      // },
      {
        path: "/FormsLibrary",
        name: "FormsLibrary",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/FormsLibrary.vue"
          ),
      },
      {
        path: "/Partner",
        name: "Partner",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/Partner.vue"
          ),
      },
      {
        path: "/QRGeneration",
        name: "QRGeneration",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/QRGeneration.vue"
          ),
      },
      {
        path: "/RFID",
        name: "RFID",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/RFID.vue"
          ),
      },
      {
        path: "/Settings",
        name: "Settings",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/Settings.vue"
          ),
      },
      {
        path: "/Splay",
        name: "Splay",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/Splay.vue"
          ),
      },
      {
        path: "/Dashboard",
        name: "Dashboard",
        component: () =>
          import(
            /* webpackChunkName: "LandingPage" */ "../views/ChildPages/Dashboard.vue"
          ),
      },
    ],
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;